const {
    NATIONAL_DOCUMENT,
    PASSPORT_DOCUMENT
} = require('../constants/documentGroups')

const {
    DOCUMENT_DN,
    DOCUMENT_PN
} = require('../constants/documentCodes')

module.exports = {
    lengthId: [9],
    lengthPassport: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    lengthResident: 0,
    patternId: "^[a-np-zA-NP-Z]{2}[a-np-zA-NP-Z0-9]{1,6}[0-9]{1}$",
    patternPassport: "^[a-zA-Z0-9]{4,15}$",
    patternResident: "",
    isValidNationalAlgorith: () => { return true },
    isValidPassportAlgorith: () => { return true },
    isValidResidentAlgorith: () => { return true },
    documentGroupMap: {
        [NATIONAL_DOCUMENT] : [DOCUMENT_DN],
        [PASSPORT_DOCUMENT] : [DOCUMENT_PN]
    }
}